export default __webpack_public_path__ + "static/media/audit.a66afb7f.png";